export default {
  namespaced: true,
  state: {
    isLessonBecameOngoing: false,
    isLessonWithinGracePeriod: false,
    isLessonBeyondGracePeriod: false,
    isLessonBeyondChatPeriod: false,
    isLessonHasEnded: false
  },
  mutations: {
    setIsLessonBecameOngoing(state, payload) {
      state.isLessonBecameOngoing = payload;
    },
    setIsLessonWithinGracePeriod(state, payload) {
      state.isLessonWithinGracePeriod = payload;
    },
    setLessonAsBeyondGracePeriod(state) {
      state.isLessonWithinGracePeriod = false;
      state.isLessonBeyondGracePeriod = true;
    },
    setLessonBeyondChatPeriod(state, payload) {
      state.isLessonBeyondChatPeriod = payload;
    },
    setIsLessonHasEnded(state, payload) {
      state.isLessonHasEnded = payload;
    }
  }
}
